import { useFeatureFlagsStore } from '@modules/feature-flags/store';
import { FeatureFlags, UseFeatureFlagsValue } from '@modules/feature-flags/types';
import { FEATURE_FLAGS_ON } from '@modules/feature-flags/constants';
import useOrganizationName from '@/modules/my-account/hooks/useOrganizationName';
import { PartnerOrganization } from '@/modules/core/types/partnerType.type';

const useFeatureFlags = (): UseFeatureFlagsValue => {
  const { featureFlags } = useFeatureFlagsStore();
  const organizationName = useOrganizationName();

  const shouldCheckFeatureFlags = (): boolean => {
    if (import.meta.env.DEV) {
      return FEATURE_FLAGS_ON;
    }

    return organizationName !== PartnerOrganization.HELIX;
  };

  const isFeatureEnabled = (featureFlag: FeatureFlags): boolean => {
    return shouldCheckFeatureFlags() ? featureFlags.includes(featureFlag) : true;
  };

  return {
    isFeatureEnabled,
  };
};

export default useFeatureFlags;
